import { DisplayField } from '@mews-commander/guest-profile';
import { TooltippedIcon } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { IconName, Typography } from '@optimus-web/core';
import { CellLayout, CellLayoutProps } from './CellLayout';

const getLabelTextKey = createHandler<DisplayField, keyof typeof TextKey | null>(
    {
        [DisplayField.AccountingCode]: 'AccountingCode',
        [DisplayField.BillingCode]: 'BillingCode',
        [DisplayField.BirthDate]: 'BirthDate',
        [DisplayField.BirthPlace]: 'BirthPlace',
        [DisplayField.CarRegistrationNumber]: 'CarRegistrationNumber',
        [DisplayField.DietaryRequirements]: 'DietaryRequirements',
        [DisplayField.Email]: 'Email',
        [DisplayField.FirstName]: 'FirstName',
        [DisplayField.LastName]: 'LastName',
        [DisplayField.LoyaltyCode]: 'LoyaltyCode',
        [DisplayField.LoyaltyMembership]: 'MembershipNumber',
        [DisplayField.NationalityCode]: 'Nationality',
        [DisplayField.Occupation]: 'Occupation',
        [DisplayField.Phone]: 'Phone',
        [DisplayField.PreferredLanguageCode]: 'Language',
        [DisplayField.SecondLastName]: 'SecondLastName',
        [DisplayField.Sex]: 'Sex',
        [DisplayField.TaxIdentifier]: 'TaxIdentifier',
        [DisplayField.TitlePrefix]: 'Title',
    },
    null
);
const tooltipedIcon = (tooltip: string) => (
    <>
        {UnicodeEntity.NoBreakSpace}
        <TooltippedIcon size="small" value={IconName.Info} tooltip={tooltip} />
    </>
);
interface LabelCellProps extends Omit<CellLayoutProps, 'children'> {
    fieldName: DisplayField;
}

export const LabelCell = ({ fieldName, ...other }: LabelCellProps) => {
    const textKey = getLabelTextKey(fieldName);

    return (
        <CellLayout {...other}>
            <Typography textStyle="bodyMedium" as="div">
                {textKey ? (
                    <>
                        {lt(textKey)}
                        {fieldName === DisplayField.LoyaltyMembership
                            ? tooltipedIcon('AccountMergeConflictingFieldsLoyaltyTooltip')
                            : null}
                    </>
                ) : null}
            </Typography>
        </CellLayout>
    );
};
